import { generateId } from '@freelancer/datastore/testing';
import { PoolModel } from './pools.model';

export interface GeneratePoolOptions {
  readonly name: string;
  readonly displayName: string;
  readonly isTalentNetwork?: boolean;
  readonly isTestPool?: boolean;
  readonly dateCreated?: number;
  readonly isInsourceEnabled?: boolean;
  readonly isCurrencyEnabled?: boolean;
}

export function generatePoolObject({
  name,
  displayName,
  isTalentNetwork = false,
  isTestPool = false,
  dateCreated = Date.now(),
  isInsourceEnabled = false,
  isCurrencyEnabled = true,
}: GeneratePoolOptions): PoolModel {
  return {
    id: generateId(),
    name,
    displayName,
    isTalentNetwork,
    isTestPool,
    dateCreated,
    isInsourceEnabled,
    isCurrencyEnabled,
  };
}

export function generatePoolObjects(
  pools: readonly PoolModel[],
): readonly PoolModel[] {
  return pools;
}

export function freelancerPool(): PoolModel {
  return {
    id: 1,
    name: 'freelancer',
    displayName: 'Freelancer',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function deloittePool(): PoolModel {
  return {
    id: 2,
    name: 'deloitte_dc',
    displayName: 'Deloitte',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: true,
    isCurrencyEnabled: false,
  };
}

export function arrowPool(): PoolModel {
  return {
    id: 3,
    name: 'arrow',
    displayName: 'Arrow',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function facebookPool(): PoolModel {
  return {
    id: 4,
    name: 'facebook',
    displayName: 'Facebook',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function talentNetworkPool(): PoolModel {
  return {
    id: 11,
    name: 'big_talent_marketplace',
    displayName: 'Big Talent Marketplace',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function anotherTalentNetworkPool(): PoolModel {
  return {
    id: 12,
    name: 'spectacular_seeds',
    displayName: 'Spectacular Seeds Ltd',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}
